import styled, { css } from 'styled-components/macro';

export const RtfContainer = styled.div<{ thumbnail?: boolean }>`
  padding: 16px;
  background-color: #FFFFFF;
  
  svg {
    display: none;
  }
  
  img {
    max-width: 100%;
  }
  
  ${(props) =>
    props.thumbnail &&
    css`
      padding: 2px;
      * {
        font-size: 8px !important;
      }
      
      div {
        margin-bottom: 4px !important;
        min-height: 5px !important;
      }
    `}
`;
